import DogInfo from './DogInfo';
import { connect } from 'react-redux';
import {
  updateOrder,
  checkEmail,
  updateOrderInquery,
  updateCustomerLastCompletedStep
} from '../../Actions';

const mapStateToProps = (state) => {
  return {
    emailInUse: state.user.emailInUse,
    orderUpdate: state.updateOrder,
    orderSubmit: state.orderSubmit.data,
    pricingCalc: state.pricingCalc.data
  }
}

const actionCreators = {
  updateOrder,
  checkEmail,
  updateOrderInquery,
  updateCustomerLastCompletedStep
}

export default (connect(mapStateToProps, actionCreators)(DogInfo));